export function fullTrim(value: string): string {
  return value?.trim()?.replace(/[\s]+/g, ' ');
}
